import { colors } from "colors"
import { StyleSheet } from "react-native"
import { typography } from "theme"

export const style = StyleSheet.create({
  buttonContainer: { flex: 1, justifyContent: "flex-end", marginBottom: 30, minHeight: 70 },
  cell: {
    borderColor: colors.inputFieldBorder,
    borderRadius: 10,
    borderWidth: 1,
    fontSize: 24,
    height: 40,
    lineHeight: 33,
    textAlign: "center",
    width: 40,
  },
  container: { height: "100%", marginHorizontal: 10 },
  disabledButton: {
    opacity: 0.5,
  },
  disabledInput: {
    opacity: 0.5,
  },
  dropdown: {
    backgroundColor: colors.inputFieldBackground,
    borderColor: colors.inputFieldBorder,
    borderRadius: 999,
    borderWidth: 1,
    flexDirection: "row",
    justifyContent: "center",
    marginBottom: 6,
    marginTop: 10,
    minHeight: 50,
    paddingRight: 10,
    width: "100%",
  },
  errorCell: {
    borderColor: colors.error,
  },

  fieldTitle: {
    fontFamily: typography.primary.normal,
    fontSize: 12,
    fontWeight: "600",
    marginBottom: 6,
    marginTop: 10,
    paddingLeft: 4,
  },
  flex: { backgroundColor: colors.white, flex: 1 },
  focusCell: {
    borderColor: colors.linearFirstColor,
  },
  idContainer: { flexDirection: "row", justifyContent: "space-between" },
  idNoContainer: { flex: 1, marginLeft: 10 },
  idTypeContainer: { flex: 1 },
  inputContainer: { alignSelf: "center", marginTop: 10 },
  inputStyle: {
    height: 50,
    paddingLeft: 10,
    paddingVertical: 10,
    width: "100%",
  },
  loginButton: { marginBottom: 20 },
  mb10: { marginBottom: 10 },
  mv30: { marginTop: 20, marginBottom: 30 },
  title: {
    fontFamily: typography.primary.normal,
    fontSize: 12,
    marginBottom: 6,
    paddingLeft: 4,
  },
  titleContainer: {
    backgroundColor: colors.white,
    left: 20,
    opacity: 1,
    position: "absolute",
    top: 2,
    zIndex: 9999,
  },
  titleText: { fontFamily: typography.primary.normal, fontSize: 23, marginBottom: 10 },

  tncContainer: { alignItems: "center", flexDirection: "row", marginTop: 10 },

  tncText: { flex: 1, fontFamily: typography.primary.normal },

  radiocontainer: { flexDirection: "row", marginVertical: 4 },

  radioButtonIcon: {
    borderRadius: 7,
    height: 14,
    width: 14,
    borderColor: "#E6E6E6",
    borderWidth: 3,
  },
  orContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginVertical: 15,
  },
  line: {
    flex: 1,
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
    marginHorizontal: 10,
  },
  orText: {
    fontFamily: typography.primary.normal,
    fontSize: 12,
    color: "#666",
    marginHorizontal: 10,
  },
})
